import React from "react";
import styles from "./ProductShopperCard.module.css"
import {Button, Carousel} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {formatPrice} from "../../utils/format";
import WalmartLogoDarkSVG from "../../images/walmar-logo-dark.svg";

export function ProductShopperCard({productoStrapi, shopper}) {

    //Unificar formato imagenes
    let imagenes = [];
    if (productoStrapi.imagenes !== undefined && productoStrapi.imagenes !== null) {
        if (Array.isArray(productoStrapi.imagenes.data)) {
            // Array de medias
            for (let i = 0; i < productoStrapi.imagenes.data.length; i++) {
                const imagen = productoStrapi.imagenes.data[i].attributes
                imagen.id = productoStrapi.imagenes.data[i].id
                imagenes.push(imagen);
            }
        } else if (Array.isArray(productoStrapi.imagenes)) {
            // Array directo
            imagenes = productoStrapi.imagenes;
        } else if (productoStrapi.imagenes.url) {
            // Media única
            imagenes.push({url: productoStrapi.imagenes.url, id: productoStrapi.imagenes.id});
        }
    }

    const producto = {
        id: productoStrapi.id,
        nombre: productoStrapi.nombre || '',
        descripcion: productoStrapi.descripcion || '',
        imagenes: imagenes,
        imagen: imagenes.length > 0 ? imagenes[0].url : undefined,
        precio: productoStrapi.precio || 0,
        tipos: Array.isArray(productoStrapi.tipos) ? productoStrapi.tipos : [],
        precioEspecial: productoStrapi.precioEspecial,
        esRollback: productoStrapi.esRollback || false,
        esCompraExcepcional: productoStrapi.esCompraExcepcional || false,
        esTopPick: productoStrapi.esTopPick || false,
        esLiquidacion: productoStrapi.esLiquidacion || false,
        shopper: shopper,
        descripcionNueva: productoStrapi.descripcionNueva,
        cta: productoStrapi.cta,
    }

    const navigate = useNavigate();

    return (
        <div className={`ps-4 bg-white p-4`}>
            <div>{producto.imagenes.length == 1 ? <img width="100%" height="auto" className={styles.productImage} src={`${producto.imagen}`} alt='img-product'/>
                : <Carousel fade={true} interval={null} className={`${styles.carouselColor}`}>
                    {
                        producto.imagenes.map((element, index) => {
                            return (
                                <Carousel.Item key={index}>
                                    <img
                                        width={"100%"} height={"auto"}
                                        className={`${styles.productImage} mx-auto d-block`}
                                        src={element.url}
                                        alt="First slide"
                                    />
                                </Carousel.Item>
                            )
                        })
                    }
                </Carousel>}</div>

            <div className={`d-inline-flex mt-4`}>
                {producto.esLiquidacion ? <div className={`${styles.esLiquidacion} d-flex px-2 py-1 mb-3 mr-1`}>Liquidación</div> : null}
                {producto.esRollback ? <div className={`${styles.rollback} d-flex px-2 py-1 mb-3 mr-1`}>Rollback</div> : null}
                {producto.esCompraExcepcional ?
                    <div className={`${styles.compraExcepcional} d-flex px-2 py-1 mb-3 mr-1`}>Compra excepcional</div> : null}
                {producto.esTopPick ?
                    <div className={`${styles.esTopPick} d-flex px-2 py-1 mb-3`}>
                        <img width={15} height={15} className={`align-self-center`} src={WalmartLogoDarkSVG} alt='walmartlogo'></img>Top Toy</div> : null}
                {!producto.esCompraExcepcional && !producto.esRollback  && !producto.esTopPick  && !producto.esLiquidacion ?
                    <div className={`${styles.box} px-2 pt-1 mb-3`}/> : null}
            </div>

            <div className={`mr-5`}>
                <div className={`fw-bold my-1 fs-3 min-h-80`}>{producto.nombre}</div>
                {producto.descripcionNueva ? <div className={`my-1 fs-5 min-h-150`} dangerouslySetInnerHTML={{__html: producto.descripcionNueva}} />:
                    <div className={`my-1 fs-5 min-h-150`}>{producto.descripcion}</div>}
            </div>
            <div className={`fw-bold my-1 fs-5`}>
                <div className={styles.tipProd}>
                    {producto.tipos.length > 0 ?
                        producto.tipos.map((tipProd, index) =>
                            <React.Fragment key={index}>{index ? ' , ' : ''}<span>{tipProd.tipo}</span></React.Fragment>
                        )
                        : null}
                </div>
                <div className={"my-4"}>
                    <span
                        className={`fs-3 ${producto.esRollback ? styles.colorRollback : ''} ${producto.esCompraExcepcional ? styles.colorPrecioEspecial : ''}`}>
                        {producto.precioEspecial ? formatPrice(producto.precioEspecial) : formatPrice(producto.precio)}
                    </span> {` `}
                    {producto.precioEspecial ?
                        <span className={`font-weight-normal fs-3 text-decoration-line-through ${styles.precioAnterior}`}>
                        <span> Antes </span>
                            {formatPrice(producto.precio)}
                        </span>
                        : null}
                </div>
            </div>

            <div>
                {producto.cta && producto.cta.enable ? <Button id={producto.cta.gtm} onClick={() => {
                    if (producto.cta.external) {
                        window.open(producto.cta.link, '_blank');
                    } else {
                        navigate(producto.cta.link)
                    }
                }} className={`${styles.button} mx-2`} style={{background: producto.cta.color, borderColor: producto.cta.color}}>
                    <span className={`mx-1  fs-5 fw-bold`}>{producto.cta.texto}</span>
                </Button> : null}
            </div>
        </div>
    )
}

export default ProductShopperCard;
